import { Modal, Form } from "react-bootstrap";
import { useState } from "react";
import { Button } from "./Controls/Button";
import { HeaderText } from "./Controls/HeaderText";

type Props = {
  show: boolean;
  onClose: () => void;
  onConfirm: (groupId: number | null) => void;

  parkerName: string;
  currentGroupId?: number | null;
  groups: { id: number; name: string }[];
};

export function ChangeParkerGroupModal({
  show,
  onClose,
  onConfirm,
  parkerName,
  currentGroupId,
  groups,
}: Props) {
  const [selectedGroupId, setSelectedGroupId] = useState<number | null>(
    currentGroupId ?? null
  );

  const isChange = !!currentGroupId;

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <HeaderText>{isChange ? "Change Group" : "Assign to Group"}</HeaderText>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-3">
          <strong>{parkerName}</strong>
        </p>

        <Form.Group>
          <Form.Label>Group</Form.Label>
          <Form.Select
            value={selectedGroupId ?? ""}
            onChange={(e) =>
              setSelectedGroupId(e.target.value ? Number(e.target.value) : null)
            }
          >
            <option value="">Select a group</option>
            {groups.map((g) => (
              <option key={g.id} value={g.id}>
                {g.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose}>Cancel</Button>

        <Button
          className="btn-main"
          disabled={!selectedGroupId}
          onClick={() => {
            onConfirm(selectedGroupId);
            onClose();
          }}
        >
          {isChange ? "Change Group" : "Assign to Group"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}